module.exports = __webpack_public_path__ + "img/second_appointment_text1.29b63b97.png";